import { render, staticRenderFns } from "./MultiForm.vue?vue&type=template&id=708d44c0&scoped=true"
import script from "./MultiForm.vue?vue&type=script&lang=js"
export * from "./MultiForm.vue?vue&type=script&lang=js"
import style1 from "./MultiForm.vue?vue&type=style&index=1&id=708d44c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708d44c0",
  null
  
)

export default component.exports